import styled from '@emotion/styled';
import Page from 'components/Page';

export const DataUpload = styled(Page)``;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 2rem;
`;
export const ContentContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;
